import { useTooltipStyles } from '../ChartTooltipStyles';
import TimeAndStatus from './TimeAndStatus';
import MetricList from './MetricList';

export default function BuiltInTooltip({ chartDef, timeslice }) {
    const classes = useTooltipStyles();

    if (!timeslice) return null;

    return (
        <div>
            <TimeAndStatus chartDef={chartDef} timeslice={timeslice} />

            <table className={classes.tooltipTable}>
                <tbody>
                    <MetricList chartDef={chartDef} timeslice={timeslice} />
                </tbody>
            </table>
        </div>
    );
}
